import { Navigate, Outlet, useLocation, Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { useAuth } from '@/contexts/AuthContext';
import { usePendingJobs } from '@/hooks/usePendingJobs';

function AppLayout() {
  const { user } = useAuth();
  const location = useLocation();
  const { data: pendingJobs = [] } = usePendingJobs();

  // Redirect users who must change their password to /settings.
  // Do not redirect if they are already on /settings (would loop).
  if (user?.must_change_password && location.pathname !== '/settings') {
    return <Navigate to="/settings" replace />;
  }

  const pendingCount = pendingJobs.length;

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        backgroundColor: 'var(--color-dark-base)',
        overflow: 'hidden',
      }}
    >
      <Sidebar />
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          overflow: 'hidden',
        }}
      >
        <TopBar />

        {/* Global pending-jobs banner — only visible when evaluations are in flight */}
        {pendingCount > 0 && (
          <div
            role="status"
            aria-live="polite"
            style={{
              backgroundColor: 'var(--color-accent-blue, #2563eb)',
              color: 'var(--color-text-inverse)',
              fontSize: '0.8125rem',
              padding: '6px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexShrink: 0,
            }}
          >
            {/* Minimal spinning indicator */}
            <svg
              style={{ width: 14, height: 14, animation: 'spin 1s linear infinite', flexShrink: 0 }}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.3" />
              <path
                d="M12 2a10 10 0 0 1 10 10"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
            <span>
              {pendingCount === 1
                ? '1 evaluation in progress'
                : `${pendingCount} evaluations in progress`}
            </span>
            <Link
              to="/evaluations"
              style={{ color: 'rgba(255,255,255,0.85)', textDecoration: 'underline', marginLeft: 4 }}
            >
              View
            </Link>
          </div>
        )}

        <main
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '24px',
          }}
          className="lg:p-8"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
